<template>
  <div class="gw-det">
    <!-- <template v-if="project.events != null">
      <Traceability :project="project" v-if="project.events.length > 0"/>
      <br>
    </template> -->
    <div v-if="showInformation">
      <!-- 1. Quien es, en que estado esta y cuanto lleva -->
      <ProjectHeader :project="project"/>
      <br>

      <!-- 2. El relato: que paso en cada validacion y quien tenia el caso.
           Va por delante de los hallazgos porque es lo que responde la
           pregunta que trae el cliente. Se dibuja solo si el proceso tiene
           trazabilidad. -->
      <ProjectSlaTimeline :projectId="project.id"/>
      <br>

      <!-- 3. Los hallazgos, juntos y bajo su propio rotulo. Antes estaban
           intercalados con las observaciones y el formulario, cada uno en su
           tarjeta y con el mismo peso visual, de modo que no habia lectura,
           solo scroll. -->
      <h2 class="gw-det-group">Hallazgos</h2>

      <template v-if="tieneRestricciones">
        <ProjectRestrictions :project="project"/>
        <br>
      </template>

      <ProjectConceptGeneral :project="project"/>
      <br>

      <template v-if="tieneVerificacionJudicial">
        <ProjectJudicialVerification :project="project"/>
        <br>
      </template>

      <template v-if="project.credit_validation">
        <ProjectCreditValidation :project="project"/>
        <br>
      </template>

      <!-- 4. El detalle, despues y rotulado como lo que es -->
      <h2 class="gw-det-group">Detalle del proceso</h2>

      <ProjectObservations :project="project"/>
      <br>
      <ProjectDataForm :project="project"/>
      <template v-if="project.project_photos != null">
        <br>
        <ProjectPhotos :project="project" v-if="project.project_photos.length > 0"/>
      </template>
      <template v-if="project.project_archives != null">
        <br>
        <ProjectArchives :project="project" v-if="hasDownloadableArchives"/>
      </template>
      <br>
      <vx-card>
        <h3 class="gw-det-title">Descargas</h3>
        <p class="gw-det-sub">El informe completo y el resumen, en PDF.</p>
        <vs-button
          v-if="userInfo.user.client_id === 1017 && userInfo.user.role_name === 'Cliente'"
          class="button-report"
          type="gradient"
          style="background: #640064;"
          disabled
        >
          No disponible
        </vs-button>
        <vs-button
          v-else-if="project.project_type_name === 'Prueba de poligrafía' && isPolygraphFileUrl(project.polygraph_attachment)"
          class="button-report"
          type="gradient"
          style="background: #640064;"
          @click="openPolygraphAttachment()"
          target="_blank"
        >
          Descargar reporte de poligrafía
        </vs-button>
        <vs-button
          v-else-if="project.project_type_name !== 'Prueba de poligrafía'"
          class="button-report"
          type="gradient"
          style="background: #640064;"
          @click="linkToReport()"
          target="_blank"
        >
          Descargar reporte
        </vs-button>
        <vs-button
          v-else
          class="button-report"
          type="gradient"
          style="background: #640064;"
          @click="linkToReport()"
          target="_blank"
        >
          Descargar reporte
        </vs-button>
        <vs-button
          class="button-report"
          type="gradient"
          style="background: #640064;"
          @click="linkToResumen()"
          target="_blank"
        >
          Descargar resumen
        </vs-button>
      </vx-card>
      <br>
      <modal-message :modalActive="progressReport"/>
    </div>
  </div>
</template>
<script>
// import Traceability from './Traceability.vue'
import ProjectHeader from './ProjectHeader.vue'
import ProjectSlaTimeline from './ProjectSlaTimeline.vue'
import ProjectConceptGeneral from './ProjectConceptGeneral.vue'
import ProjectDataForm from './ProjectDataForm.vue'
import ProjectObservations from './ProjectObservations.vue'
import ProjectCreditValidation from './ProjectCreditValidation.vue'
import ProjectJudicialVerification from './ProjectJudicialVerification.vue'
import ProjectAnalyst from './ProjectAnalyst'
import ProjectPhotos from './ProjectPhotos'
import ProjectArchives from './ProjectArchives'
import api from '../../mixins/api.js'
import secureFiles from '../../mixins/secureFiles.js'
import { isPolygraphFileUrl, isPresignedOrExternalFileUrl } from '@/utils/secureFileUrl'
import { mapGetters } from 'vuex'
import ModalMessage from './../ModalMessage'
import { eventBus } from './../../main'
import ProjectRestrictions from './ProjectRestrictions.vue'
export default {
  mixins: [api, secureFiles],
  props: {
    popupShowActive: Boolean,
    project: Object,
  },
  data (){
    return{
      colorx:"rgba(255,255,255,255)",
      progressReport:false,
      showInformation: true
    }
  },
  methods: {
    isPolygraphFileUrl,
    async linkToReport(){
      let fileName = this.project.project_person_full_name + " - " + this.project.project_type_name + " - " + this.project.person_id
      console.log(fileName)
      await this.linkReport(this.project.id,this.userInfo.user.id,fileName)
    },
    goToProject(){
      this.$router.push('project')
    },
    async linkToResumen(){
      let fileName = this.project.project_person_full_name + " - " + this.project.project_type_name + " - " + this.project.person_id
      await this.linkResumen(this.project.id,this.userInfo.user.id,fileName)
    },
    openPolygraphAttachment () {
      this.openSecureFileUrl(this.project.polygraph_attachment, {
        resourceType: 'project_attachment',
        id: this.project.id,
        attachment: 'polygraph_attachment'
      })
    }
  },
  created(){
    this.role_name = this.userInfo.user.role_name;
    this.client_id = this.userInfo.user.client_id;

  },
  mounted(){
    eventBus.$on('toggleInformationFull', (value) => {
      this.showInformation = value
    })
  },
  components:{
    // Traceability,
    ProjectHeader,
    ProjectSlaTimeline,
    ProjectConceptGeneral,
    ProjectDataForm,
    ProjectObservations,
    ProjectCreditValidation,
    ProjectJudicialVerification,
    ProjectAnalyst,
    ProjectPhotos,
    ProjectArchives,
    ModalMessage,
    ProjectRestrictions
  },
  computed:{
    ...mapGetters(['userInfo']),
    hasDownloadableArchives () {
      const archives = this.project.project_archives || []
      return archives.some((archive) => isPresignedOrExternalFileUrl(archive.url))
    },

    // `project` empieza como {} y se llena despues, asi que estas listas no
    // existen en el primer render. Las otras dos ya tenian su guardia; esta
    // no, y tiraba un error de render en cada carga del detalle.
    tieneRestricciones(){
      var r = (this.project || {}).observation_restrictions
      return Array.isArray(r) && r.length > 0
    },

    tieneVerificacionJudicial(){
      var j = (this.project || {}).judicial_verification
      return Array.isArray(j) && j.length > 0
    }
  }

}
</script>

<style>
  .vs-popup{
    width: 80% !important;
  }
  .button-report{
    margin-right: 1rem !important;
  }

  /* ---------------------------------------------------------------------
     Lenguaje visual del detalle del proceso.
     Sin scope a proposito: lo comparten todas las tarjetas de la vista, que
     antes definia cada una lo suyo. De ahi que todo pesara lo mismo.
     --------------------------------------------------------------------- */

  /* Rotulo de grupo: separa los hallazgos del detalle */
  .gw-det-group{
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .08em;
    text-transform: uppercase;
    color: #9a9a9a;
    margin: 6px 0 10px 4px;
  }

  /* Titulo de tarjeta: a la izquierda y del mismo tamano en todas. Antes
     cada una centraba un h4 o un h3, que compite con el contenido alineado
     a la izquierda que viene debajo. */
  .gw-det-title{
    font-size: 15px;
    font-weight: 700;
    color: #3b3b3b;
    margin: 0 0 4px;
  }
  .gw-det-sub{
    font-size: 12px;
    color: #9a9a9a;
    margin: 0 0 18px;
    max-width: 76ch;
    line-height: 1.5;
  }

  /* Par etiqueta/valor */
  .gw-det-kv{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
    gap: 14px 24px;
  }
  .gw-det-label{
    font-size: 10.5px;
    font-weight: 600;
    letter-spacing: .05em;
    text-transform: uppercase;
    color: #9a9a9a;
    margin-bottom: 2px;
  }
  .gw-det-value{
    font-size: 13.5px;
    color: #3b3b3b;
    word-break: break-word;
  }

  /* El formulario del candidato usa .table-title para sus etiquetas: se
     reestilan para que hablen el mismo idioma que el resto. Va acotado a
     .gw-det porque es una clase compartida: ProjectHeaderPreliminary tambien
     la usa y no se quiere tocar. */
  .gw-det .table-title{
    font-size: 10.5px !important;
    font-weight: 600 !important;
    letter-spacing: .05em;
    text-transform: uppercase;
    color: #9a9a9a !important;
    margin-bottom: 2px !important;
  }

  .gw-det-fila{
    padding: 12px 0;
    border-bottom: 1px solid #f4f4f4;
  }
  .gw-det-fila:last-child{
    border-bottom: none;
  }
  .gw-det-fecha{
    font-size: 11px;
    color: #9a9a9a;
    margin-bottom: 3px;
  }
  .gw-det-texto{
    font-size: 13.5px;
    color: #3b3b3b;
    line-height: 1.55;
    word-break: break-word;
  }
  .gw-det-vacio{
    font-size: 12.5px;
    color: #9a9a9a;
  }
</style>
